import { render } from "./Pelamar.vue?vue&type=template&id=c1df4d40"
import script from "./Pelamar.vue?vue&type=script&lang=js"
export * from "./Pelamar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__